export default __webpack_public_path__ + "static/media/doug-mcintosh.88aebbcc.png";